const GTM_ID = process.env.REACT_APP_GTM_ID;
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

export function initAnalytics() {
  if (window.__lgAnalytics) return;
  window.__lgAnalytics = true;
  window.dataLayer = window.dataLayer || [];
  if (GTM_ID) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    addScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);
  }
  if (GA4_ID) {
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
  }
}

export function trackPurchase({ orderId, tierId, tierName, amount }) {
  const ecommerce = {
    transaction_id: orderId,
    value: amount,
    currency: "INR",
    items: [{ item_id: tierId, item_name: tierName, item_category: "Package", price: amount, quantity: 1 }],
  };
  if (GA4_ID && window.gtag) window.gtag("event", "purchase", ecommerce);
  if (GTM_ID) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: "purchase", ecommerce });
  }
}

export function trackPageView(path) {
  if (window.__lgLastPath === path) return;
  window.__lgLastPath = path;
  const page = { page_path: path, page_location: window.location.href, page_title: document.title };
  if (GA4_ID && window.gtag) window.gtag("event", "page_view", page);
  if (GTM_ID) window.dataLayer.push({ event: "virtual_page_view", ...page });
}
